window.GameJunction = Junction.extend({

    showStartPage: function() {
        this.isCompleted = false;
        this.startPage = this.app.storage.getItem(GameJunction.BOOKMARK);
        this.navigation = this.app.getComponent("SiNavigationManager");
        var jumpPage;
        if (this.startPage != -1) {
            jumpPage = this.startPage;
        } else {
            jumpPage = this.gameData.modules.models[0].pages[0].attributes.pageID;
        }

        this.app.router.navigate("#page/" + jumpPage, {
            trigger: true
        });
    },

    handleJunctionUpdate: function(pageData) {
        Junction.prototype.handleJunctionUpdate.call(this, pageData);

        var nextPageID = pageData.pageID;
        if (this.gameController.isPreviousClicked === true) {
            this.app.router.navigate("#page/" + this.previousPage, {
                trigger: true
            });
        } else if (nextPageID == "home") {
            this.complete();
            this.isCompleted = true;
            this.navigation.setProgress(100);

            this.app.router.navigate("#page/" + this.nextPage, {
                trigger: true
            });
        } else {
            this.app.storage.setItem(GameJunction.BOOKMARK, nextPageID);
            this.updateProgress(pageData);
        }
    },

    updateProgress: function(pageData) {
        var totalPages = this.gameData.getModule(0).getTotalPages();
        var pageNumber = this.gameController.currentPageData.pageNumber();
        var percentage = Math.round((pageNumber * 100) / totalPages);

        this.navigation.setProgress(percentage);
    },

    getData: function() {
        this.gameData = new GameCourseData(this.app);
        this.gameData.score = 1;
        this.gameData.passmark = 1;

        this.previousPage = this.blockData.getArg("previousPage");
        this.nextPage = this.blockData.getArg("nextPage");

        this.gameController = new GameController(this.app, this.gameData, this.$stage, this);
        this.gameTracking = new JunctionTracking(this.app, this.gameController, this.gameData);
        this.junctionAudio = new JunctionAudio(this.app, this.gameController.pageRenderer);
    }
}, {
    BOOKMARK: "gameStartPage"
});
